import { createTheme } from '@mui/material/styles';

import breakpoints from 'utils/breakpoints';
import { getColor } from 'utils/colors';
import mixins from 'utils/mixins';
import { remCalc } from 'utils/remCalc';

const theme = createTheme({
	breakpoints: breakpoints,
	mixins: mixins,
});

export const styles = {};

export const overrides = {

	'@keyframes fadeIn': {
		'0%': { opacity: 1 },
		'20%': { opacity: 0 },
		'100%': { opacity: 1 }
	},

	'.eventCard__card': {
		// '--transition-duration': '3s',
		position: 'relative',
		height: remCalc(309),
		borderRadius: 0,
		overflow: 'hidden',
		...theme.mixins.glass,
		backgroundColor: getColor('white', 400),
		transition: 'background-color var(--transition-duration) ease',
		'.eventCard__actionArea': {
			position: 'relative',
			zIndex: 1,
			height: '100%',
			display: 'flex',
			alignItems: 'flex-end',
			textDecoration: 'none',
			color: getColor('ivory', 700),
			'&:hover': {
				textDecoration: 'none',
			},
			'&:focus-visible': {
				outline: `${remCalc(2)} solid ${getColor('blue', 400)}`,
				outlineOffset: `-${remCalc(2)}`,
			},
		},
		'.eventCard__content__titleArea': {
			// width: '100%',
			display: 'flex',
			flexDirection: 'column',
			// justifyContent: 'flex-end',
			gap: remCalc(20),
			// padding: remCalc(40),
			// height: '100%',
			// transition: 'gap .35s ease',
			// color: getColor('ivory', 700),
		},
		'.eventCard__content__infoArea': {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'flex-end',
			gap: remCalc(20),
			maxHeight: remCalc(64),
			transition: 'opacity var(--transition-duration) ease, transform var(--transition-duration) ease, max-height var(--transition-duration) ease, gap var(--transition-duration) ease',
		},

		'.eventCard__content': {
			width: '100%',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'flex-end',
			gap: remCalc(40),
			padding: remCalc(40),
			height: '100%',
			transition: 'gap var(--transition-duration) ease',
			color: getColor('ivory', 700),
		},
		'.eventCard__cardSubtitle': {
			color: getColor('ivory', 700),
			margin: 0,
			maxHeight: remCalc(14),
			// overflow: 'hidden',
			opacity: 1,
			// transform: 'translateY(0)',
			letterSpacing: remCalc(-0.25),
			textTransform: 'uppercase',
			transition: 'opacity var(--transition-duration) ease, transform var(--transition-duration) ease, max-height var(--transition-duration) ease',
			lineHeight: '14px',
			padding: 0,
		},
		'.eventCard__cardTitle': {
			margin: 0,
			letterSpacing: remCalc(0.5),
			textTransform: 'capitalize',
			// transition: 'font-size var(--transition-duration) ease, line-height var(--transition-duration) ease, letter-spacing var(--transition-duration) ease',
			transition: 'margin var(--transition-duration) ease, transform var(--transition-duration) ease',
			// transition: 'margin var(--transition-duration) ease, transform var(--transition-duration) ease, font-size var(--transition-duration) ease',
			color: getColor('ivory', 700),
			fontSize: remCalc(32),
			lineHeight: '1.25',
			// lineHeight: remCalc(36),
			[theme.breakpoints.up('md')]: {
				// marginBottom: remCalc(20),
	        },
		},
		'&.animate': {
			'.eventCard__cardTitle': {
				animation: 'fadeIn .6s linear',
			}
		},
		'.eventCard__cardIconRow': {
			display: 'flex',
			flexDirection: 'row',
			gap: remCalc(10),
			alignItems: 'center',
			transition: 'opacity var(--transition-duration) ease, transform var(--transition-duration) ease, max-height var(--transition-duration) ease',
		},
		'.eventCard__cardIcon': {
			width: remCalc(14),
			'&.locationPin': {
				width: 'unset',
				height: remCalc(16),
				flex: 'auto 0 0'
			}
		},
		'.eventCard__overlay': {
			// position: 'absolute',
			// inset: 0,
			// background: 'rgba(0, 0, 0, 0.3)',
			// transition: 'background-color .2s',
			display: 'none',
		},
		'.eventCard__media': {
			position: 'absolute',
			inset: 0,
			backgroundRepeat: 'no-repeat',
			backgroundSize: 'cover',
			backgroundPosition: 'center',
			transition: 'transform var(--transition-duration) ease',
		},
		'&:focus-within': {
			backgroundColor: getColor('ivory', 400),
			'.eventCard__media': {
				transform: 'scale(1.22)',
			},
			'.eventCard__overlay': {
				background: 'rgba(0, 0, 0, 0.2)',
			},
			'.eventCard__content': {
				gap: 0,
			},
			'.eventCard__cardSubtitle': {
				opacity: 0,
				// maxHeight: 0,
				// transform: 'translateY(-8px)',
				transform: 'translateY(100%) scaleY(0)',
			},
			'.eventCard__cardIconRow': {
				opacity: 0,
				// maxHeight: 0,
				transform: 'translateY(100%)',
			},
			'.eventCard__content__infoArea': {
				gap: 0,
				// opacity: 0,
				maxHeight: 0,
			},
			'.eventCard__cardTitle': {
				// transform: 'scale(1.2)',
				fontSize: remCalc(39),
				animation: 'fadeIn .4s 1 ease-in-out',
				// lineHeight: remCalc(47),
				// letterSpacing: remCalc(0.5),
				// marginBottom: 0,
			},
		},
		'@media (hover: hover) and (pointer: fine)': {
			'&:hover': {
				backgroundColor: getColor('ivory', 400),
				'.eventCard__media': {
					transform: 'scale(1.22)',
				},
				'.eventCard__overlay': {
					background: 'rgba(0, 0, 0, 0.2)',
				},
				'.eventCard__content': {
					gap: 0,
				},
				'.eventCard__cardSubtitle': {
					opacity: 0,
					// maxHeight: 0,
					// transform: 'translateY(-8px)',
					transform: 'translateY(100%) scaleY(0)',
				},
				'.eventCard__cardIconRow': {
					opacity: 0,
					// maxHeight: 0,
					transform: 'translateY(100%)',
				},
				'.eventCard__content__infoArea': {
					gap: 0,
					// opacity: 0,
					maxHeight: 0,
				},
				'.eventCard__cardTitle': {
					// transform: 'scale(1.2)',
					fontSize: remCalc(39),
					// animation: 'fadeIn .4s 1 ease-in-out',
					// lineHeight: remCalc(47),
					// letterSpacing: remCalc(0.5),
					// marginBottom: 0,
				},
			},
		},
	},

	'@media (prefers-reduced-motion: reduce)': {
		'.eventCard__media, .eventCard__overlay, .eventCard__content, .eventCard__cardSubtitle, .eventCard__cardTitle': {
			transition: 'none',
		},
	},
};

export default styles;
